import { List, Map } from "immutable";
import { SimpleStore } from "@core/store/store";
import { Application, ApplicationFilterOptions } from "./application";
import { ApplicationApi } from "./applicationApi";
import { ApplicationDraft } from "./applicationDraft";

import { ComplexMappedStorePresentation } from "@core/store/mappedStorePresentation";
import { ApplicationDegree, ApplicationLevel } from "@domain/program/programDraft";
import { ApplicationVoteDto } from "./dtos";

export class ApplicationService {
	applicationStore = new SimpleStore((id) => this.applicationApi.get(id));

	applicationsStore = new ComplexMappedStorePresentation<Application, { filterOption?: ApplicationFilterOptions }>(
		this.applicationStore,
		({ filterOption }, page) => this.applicationApi.listApplications(filterOption, page)
	);

	constructor(
		private readonly applicationApi: ApplicationApi,
		initialApplication?: Map<string, Application>
	) {
		if (initialApplication) {
			this.applicationStore.merge(List(initialApplication.values()));
		}
	}

	async save(draft: ApplicationDraft): Promise<Application> {
		const application = await this.applicationApi.save(draft);
		// this.applicationStore.save(application);
		return application;
	}

	async create(draft: ApplicationDraft): Promise<Application> {
		const application = await this.applicationApi.create(draft);
		//this.applicationStore.save(application);
		return application;
	}

	async getDegreeLevel(): Promise<Array<ApplicationLevel>> {
		return this.applicationApi.getDegreeLevel();
	}

	async getApplication(id: string, currentUser?: string): Promise<Application> {
		return this.applicationApi.getApplication(id, currentUser);
	}

	async getDegreeProgram(level: string): Promise<Array<ApplicationDegree>> {
		return this.applicationApi.getDegreeProgram(level);
	}

	async vote(applicationId: string, key?: string): Promise<ApplicationVoteDto> {
		return this.applicationApi.vote(applicationId, key);
	}

	async getMyApplication(): Promise<Application> {
		return this.applicationApi.getMyApplication();
	}

	shareApplication(id: string, text?: string): Promise<void> {
		return this.applicationApi.shareApplication(id, text);
	}
}
